const s = {
  name: "Servers",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M7,8.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2C6.3,5.8,5.8,6.3,5.8,7C5.8,7.7,6.3,8.3,7,8.3z"/>
		<path class="st0" d="M32,4v6h2V4H32z"/>
		<path class="st0" d="M28,10V4h2v6H28z"/>
		<path class="st0" d="M24,4v6h2V4H24z"/>
		<path class="st0" d="M8.3,19c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C7.7,17.7,8.3,18.3,8.3,19z"/>
		<path class="st0" d="M32,16v6h2v-6H32z"/>
		<path class="st0" d="M28,22v-6h2v6H28z"/>
		<path class="st0" d="M24,16v6h2v-6H24z"/>
		<path class="st0" d="M7,32.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C5.8,31.7,6.3,32.2,7,32.2z"/>
		<path class="st0" d="M34,28h-2v6h2V28z"/>
		<path class="st0" d="M28,28h2v6h-2V28z"/>
		<path class="st0" d="M26,28h-2v6h2V28z"/>
		<path class="st0" d="M0,9c0,1.6,0.8,3.1,2,4c-1.2,0.9-2,2.4-2,4v4c0,1.6,0.8,3.1,2,4c-1.2,0.9-2,2.4-2,4v4c0,2.8,2.2,5,5,5h30
			c2.8,0,5-2.2,5-5v-4c0-1.6-0.8-3.1-2-4c1.2-0.9,2-2.4,2-4v-4c0-1.6-0.8-3.1-2-4c1.2-0.9,2-2.4,2-4V5c0-2.8-2.2-5-5-5H5
			C2.2,0,0,2.2,0,5V9z M5,2h30c1.7,0,3,1.3,3,3v4c0,1.7-1.3,3-3,3H5c-1.7,0-3-1.3-3-3V5C2,3.3,3.3,2,5,2z M2,17c0-1.7,1.3-3,3-3h30
			c1.7,0,3,1.3,3,3v4c0,1.7-1.3,3-3,3H5c-1.7,0-3-1.3-3-3V17z M5,26h30c1.7,0,3,1.3,3,3v4c0,1.7-1.3,3-3,3H5c-1.7,0-3-1.3-3-3v-4
			C2,27.3,3.3,26,5,26z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Servers
};
